import { useAuth } from "@babackapp/auth-client/hooks";

/**
 * Returns true if the current viewer is a Baback team member,
 * identified by an @baback.co email address.
 */
export function useViewerIsBabackTeam(): boolean {
  const { user } = useAuth();
  return user?.emails?.some((e) => e.address?.endsWith("@baback.co")) ?? false;
}
